import { isUnitedStatesOverride } from "./modules/ak-overrides";
import { translateLinks } from "./modules/links-translation";
import { setFloatingLabels } from "./modules/floating-labels";
import { setInitiatorName } from "./modules/initiator-name";
import { toggleVisibility } from "./modules/toggle-visibility";
import { floatingProgressMeter } from "./modules/floating-progress-meter";
import { updateFormStatus } from "./modules/form-status";
import { initPopup } from "./modules/popup";
import { wmEvents } from "./modules/wm-events";
import { otherCountryField } from "./modules/other-country-field";
import { wmUtilities } from "./modules/wm-utilities";
import { inputCharCount } from "./modules/input-char-count";
import { consentInline } from "./modules/consent-inline";
import { copyToClipboard } from "./modules/copy-to-clipboard";
import { handleResize } from "./modules/handleResize";
import { wmComponents } from "./modules/wm-components";
import { flyOutMenu } from "./modules/fly-out-menu";
import { externalVideo } from "./modules/external-video";
import { formSkeletonPreloader } from "./modules/form-skeleton-preloader";
import { avoidMultipleSubmitions } from "./modules/avoid-multiple-submitions";
import { sendShareToActionKit } from "./modules/send-share-to-action-kit";
import { relatedCampaigns } from "./modules/related-campaigns";
import { tafButton } from "./modules/taf-button";
import { expandTransactionsList } from "./modules/expand-transactions-list";
import { accountTabs } from "./modules/account-tabs";
import { dialog } from "./modules/dialog";
import { editProfile } from "./modules/edit-profile";
import { preloader } from "./modules/preloader";
import { profileCard } from "./modules/profile-card";
import { cancelRecurringDonation } from "./modules/cancel-recurring-donation";
import { recurringDonationCard } from "./modules/recurring-donation-card";

// Ref: https://stackoverflow.com/questions/9081884/loading-history-js-state-after-back-button-from-other-page
history.navigationMode = "compatible";

(() => {
  const initWeMoveLibrary = () => {
    wmEvents();
    wmUtilities();
    wmComponents();
  };

  initWeMoveLibrary();

  const initAkScripts = () => {
    // Common scripts
    handleResize();
    initPopup();
    dialog();
    translateLinks();
    toggleVisibility();
    flyOutMenu();
    externalVideo();
    preloader();

    // Petition
    setInitiatorName();
    floatingProgressMeter();
    inputCharCount();

    // Share
    copyToClipboard();
    tafButton();
    sendShareToActionKit();
    relatedCampaigns();

    // Account
    expandTransactionsList();
    accountTabs();
    editProfile();
    profileCard();
    cancelRecurringDonation();
    recurringDonationCard();

    wemove.triggerEvent("wm-scriptsLoaded");
  };

  const initAkFormScripts = () => {
    // Common scripts
    setFloatingLabels();
    updateFormStatus();
    avoidMultipleSubmitions();

    // Forms
    consentInline();
    formSkeletonPreloader();
    setTimeout(otherCountryField, 0);
  };

  if (typeof actionkit.form === "undefined") {
    // This should happen only on user pages like login or me/update...
    initAkFormScripts();
  } else {
    $(actionkit.form).bind("actionkit.ready", function () {
      initAkFormScripts();
    });
  }

  window.actionkit.forms.isUnitedStates = isUnitedStatesOverride;

  window.onpopstate = () => setTimeout(initAkScripts, 0);

  if (document.readyState === "complete") {
    initAkScripts();
    return;
  }

  document.onreadystatechange = () => {
    if (document.readyState === "complete") {
      initAkScripts();
    }
  };
})();
